import React, { useEffect, useState } from 'react';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';
import { TListingClient } from 'types/TListing';

type TFeedAppProps = {
  appState: {
    listing: {
      itemId: TListingClient['itemId'];
      isCarAd: TListingClient['isCarAd'];
    };
  };
  environment: any;
};

let Feed;

const FeedApp = ({ appState, environment }: TFeedAppProps) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const {
    listing: { itemId, isCarAd },
  } = appState;

  // todo: load on scroll into view instead of mount
  useEffect(() => {
    const loadComponent = async () => {
      try {
        Feed = (await import(/* webpackChunkName: "feed" */ './components/Feed/Feed')).default;
        setIsLoaded(true);
      } catch (err) {}
    };

    loadComponent();
  }, []);

  if (!isLoaded) {
    return null;
  }

  return (
    <EnvironmentProvider value={environment}>
      <Feed itemId={itemId} isCarAd={isCarAd} />
    </EnvironmentProvider>
  );
};

export default FeedApp;
